import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

interface RemoveSubscriberProps {
    name: string
    recipient_email: string
}

export default async function removeSubscriber(params: RemoveSubscriberProps) {
    try {
        const { data } = await axios.post(
            `${config.API_BASE_URL}/notifications/remove-subscriber/`,
            params,
            {
                withCredentials: true,
            },
        )

        return data
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to remove subscriber: ${axiosError.message}`,
            axiosError,
        )

        if (error?.response?.data?.error) {
            throw new Error(error.response.data.error)
        }

        throw new Error(axiosError.message)
    }
}
